import React, { useContext } from 'react';
import {
	IScheduleViewContext,
	ScheduleViewContext,
} from '../../scheduleViewContext/scheduleViewState/scheduleViewContext';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';

const SchedulePagination: React.FC = () => {
	const { changeCurrentPage, scheduledPushes, currentPage, countOfItems } =
		useContext<IScheduleViewContext>(ScheduleViewContext);

	return (
		<PaginationComponent
			currentPage={currentPage}
			countOfItems={countOfItems}
			entitiesCount={scheduledPushes.count}
			changeCurrentPage={changeCurrentPage}
		/>
	);
};

export default SchedulePagination;
